import React from "react";
import { Box, HStack, Text, VStack, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";
import useThemeColors from "../../../../hooks/useThemeColors";
import CustomCheckBox from "../../../CustomUi/CustomCheckBox";

interface DataCustomizationCardProps {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
  icon: IconType;
  title: string;
  description: string;
  disabled?: boolean;
}

const DataCustomizationCard: React.FC<DataCustomizationCardProps> = ({
  isChecked,
  onChange,
  icon,
  title,
  description,
  disabled = false,
}) => {
  const colors = useThemeColors();

  return (
    <Box
      p={3}
      borderWidth="1px"
      borderRadius="md"
      borderColor={isChecked ? colors.brand.primary : colors.border.secondary}
      bg={isChecked ? `${colors.brand.primary}10` : colors.background.secondary}
      opacity={disabled ? 0.6 : 1}
      cursor={disabled ? "not-allowed" : "pointer"}
      transition="all 0.2s"
      _hover={
        !disabled
          ? {
              borderColor: isChecked
                ? colors.brand.primary
                : colors.border.primary,
              bg: isChecked
                ? `${colors.brand.primary}20`
                : colors.background.tertiary,
            }
          : {}
      }
      onClick={() => !disabled && onChange(!isChecked)}
    >
      <VStack align="start" gap={0} flex={1}>
       <Box onClick = {(e) => e.stopPropagation()}> <CustomCheckBox
          checked={isChecked}
          onChange={() => !disabled && onChange(!isChecked)}
          label={
            <HStack gap={2}>
              <Icon
                as={icon}
                color={isChecked ? colors.brand.primary : colors.text.secondary}
                boxSize={4}
              />
              <Text fontWeight="semibold">{title}</Text>
            </HStack>
          }
        /></Box>
        <Text fontSize="xs" color={colors.text.secondary} ml={6}>
          {description}
        </Text>
      </VStack>
    </Box>
  );
};

export default DataCustomizationCard;
